import React from "react";
import Fab, { FabProps } from "@mui/material/Fab";
import ToggleIcon from "./ToggleIcon";
import { Box } from "@mui/material";

const FAB_STYLE = {
  margin: 0,
  top: "auto",
  right: 20,
  bottom: 20,
  left: "auto",
  position: "fixed",
};

type TFloatingActionButtonProps = {
  iconName: string;
} & FabProps;

const FloatingActionButton = (props: TFloatingActionButtonProps) => {
  const { iconName, ...fabProps } = props;
  return (
    <Box sx={{ height: 80 }} display="flex" flexDirection="column">
      <Fab {...fabProps} sx={FAB_STYLE}>
        <ToggleIcon name={iconName}></ToggleIcon>
      </Fab>
    </Box>
  );
};

export default FloatingActionButton;
